import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { SITE_NAME, APP_URI } from './types';

@Component({
  selector: 'app-root',
  imports: [RouterModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'webapp';

  constructor(private titleService: Title, private metaService: Meta) {
  }

  ngOnInit() {
    // Set page title from environment
    this.titleService.setTitle(SITE_NAME);
    
    // Set meta tags from environment
    this.metaService.updateTag({ property: 'og:url', content: `${APP_URI}/` });
    this.metaService.updateTag({ property: 'og:title', content: SITE_NAME });
    this.metaService.updateTag({ name: 'twitter:title', content: SITE_NAME });
    
  }

}
